// ============================================================================
// @gs/feedback/client — admission des fichiers du composer (helpers PURS)
// ============================================================================
// CHORE-FBK-COMPOSER-V2 : LE chemin unique de validation des PJ du composer —
// trombone, glisser-deposer ET collage presse-papiers (Ctrl+V de capture
// d'ecran, le geste roi du support) passent TOUS par addPickedFiles : AUCUNE
// regle d'upload dupliquee (type/taille/nombre = memes constantes que la
// creation). Testable sans DOM (les events fournissent des File standards).

import { ATTACHMENT_CONTENT_TYPES, MAX_ATTACHMENTS, MAX_ATTACHMENT_BYTES } from '../schemas';

/** Cle d'erreur i18n (le composant mappe vers feedback:modal.attachment*Error). */
export type FileIntakeErrorKey = 'type' | 'size' | 'count' | null;

export interface FileIntakeResult {
  files: File[];
  /** Premiere violation rencontree (l'admission s'arrete la — parite picker). */
  errorKey: FileIntakeErrorKey;
}

/**
 * Ajoute `incoming` a `current` sous les contraintes existantes du picker :
 * type (image/* + pdf), taille (10 Mo), nombre (3). Premiere violation = stop
 * (le lot deja admis est conserve, parite onFilesPicked historique).
 */
export function addPickedFiles(current: File[], incoming: Iterable<File>): FileIntakeResult {
  const files = [...current];
  for (const f of incoming) {
    if (!ATTACHMENT_CONTENT_TYPES.test(f.type)) return { files, errorKey: 'type' };
    if (f.size > MAX_ATTACHMENT_BYTES) return { files, errorKey: 'size' };
    if (files.length >= MAX_ATTACHMENTS) return { files, errorKey: 'count' };
    files.push(f);
  }
  return { files, errorKey: null };
}

/** Forme minimale de DataTransfer/clipboardData (testable sans DOM). */
export interface FileCarrier {
  files?: ArrayLike<File> | null;
}

/** Fichiers d'un drop (multi-fichiers — la limite vit dans addPickedFiles). */
export function filesFromDataTransfer(dt: FileCarrier | null | undefined): File[] {
  return dt?.files ? Array.from(dt.files) : [];
}

/**
 * IMAGES d'un collage presse-papiers (capture d'ecran = File image/*). On ne
 * prend QUE les images : un Ctrl+V de texte ne doit jamais etre intercepte
 * (le texte suit son chemin natif vers le textarea).
 */
export function imageFilesFromClipboard(cd: FileCarrier | null | undefined): File[] {
  return filesFromDataTransfer(cd).filter((f) => f.type.startsWith('image/'));
}
